import * as React from 'react';
import { Link } from 'react-router-dom';
import { EmptyState } from '@ministry/ui/internal';

import { useT } from '../i18n/strings.js';

export function NotFoundPage(): React.JSX.Element {
  const t = useT();
  return (
    <div className="flex min-h-[60vh] items-center justify-center p-6">
      <EmptyState
        title={t('notFound.title')}
        body={t('notFound.body')}
        action={
          <Link to="/dashboard" className="text-sm font-semibold text-text-link underline">
            {t('notFound.action')}
          </Link>
        }
      />
    </div>
  );
}
